import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { observer, inject } from 'mobx-react';
import { FormattedMessage } from 'ui/i18n';

import './ConfirmPromptModal.scss';

@inject('ConfirmPromptState')
@observer
export default class ConfirmPromptModal extends Component {
	static propTypes = {
		ConfirmPromptState: PropTypes.object.isRequired,
		msg: PropTypes.string,
		useState: PropTypes.bool,
		show: PropTypes.bool,
		onClick: PropTypes.func,
	};

	static defaultProps = {
		msg: '',
		useState: true,
		show: false,
		onClick: () => true,
	};

	ConfirmPromptState = this.props.ConfirmPromptState;

	handleClick(choice) {
		if (this.props.useState) {
			this.ConfirmPromptState.handleClick(choice);
		} else {
			this.props.onClick(choice);
		}
	}

	render() {
		const { promptMessage, togglePrompt } = this.ConfirmPromptState;
		const { useState, show, msg } = this.props;
		return (
			<Modal
				className="ReactModal__Content ConfirmPromptModal"
				overlayClassName="ReactModal__Overlay"
				isOpen={useState ? togglePrompt : show}
				contentLabel="Confirm Prompt"
			>
				<div className="ConfirmPromptModal-warning-msg">
					<h4>
						<strong>
							<FormattedMessage id="confirmPromptModal.titleText" />
						</strong>
					</h4>
					<hr />
					<h5>
						{useState ? promptMessage : msg}
					</h5>

					<button
						className="btn btn-primary pull-right"
						onClick={this.handleClick.bind(this, 'cancel')}
					>
						<FormattedMessage id="general.cancelText" />
					</button>

					<button
						className="btn btn-primary pull-right"
						onClick={this.handleClick.bind(this, 'ok')}
					>
						OK
					</button>
				</div>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ConfirmPromptModal/index.js